import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import Contact from './Contact';

const ContactPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-black" data-testid="contact-page">
      <Helmet>
        <title>Contact Aryan Shivhare | Get a Free Marketing Audit</title>
        <meta
          name="description"
          content="Get in touch with Aryan Shivhare, a Berlin-based digital marketer. Book a free growth audit or discuss your paid social, SEO, and content marketing needs."
        />
        <meta name="keywords" content="contact Aryan Shivhare, marketing consultation Berlin, free marketing audit, hire digital marketer" />
        <link rel="canonical" href="https://aryanshivhare.com/contact" />
        <meta property="og:title" content="Contact Aryan Shivhare | Get a Free Marketing Audit" />
        <meta property="og:description" content="Book a free growth audit or discuss your marketing needs with a Berlin-based performance marketer." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://aryanshivhare.com/contact" />
      </Helmet>

      <div className="pt-16">
        <Contact />
      </div>
    </div>
  );
};

export default ContactPage;
